<style lang="sass">
@import visual
@import lazyload
</style>

<template>
    <icon v-if="svg" :src="svg" class="g_visual"/>
    <i aria-hidden="true" v-else-if="fontIcon" :class="fontIcon"/>
    <img v-else class="g_visual" loading="lazy" v-img-src="src" :alt="alt"/>
</template>
<script>
import Vue from 'vue'

export default {
    name: 'Visual',
    props: {
        src: Object,
        svg: String,
        fontIcon: String
    },
    computed: {
        alt: function () {
            return this.src && this.src.name ? this.src.name : this.src
        }
    },
    created () {
        if (this.svg) {
            Vue.component('icon', () => import(/* webpackChunkName: "Icon" */ 'nespresso-components/icon/Icon').then(m => m.default))
        }
    }
}
</script>



// WEBPACK FOOTER //
// node_modules/gvue/src/core/Visual/Visual.vue